exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._5b2ROa0p33lkUmzqOZnHC{display:\"inline-block\";font-style:\"normal\";font-weight:\"normal\";overflow:\"hidden\";text-overflow:\"ellipsis\"}._3q6xHD6HXBPeRAC20i6Hfu{width:20px;height:20px}html[dir=ltr] ._3q6xHD6HXBPeRAC20i6Hfu{margin-right:10px}html[dir=rtl] ._3q6xHD6HXBPeRAC20i6Hfu{margin-left:10px}._2-EZ4euowYj-m7jtrkmKQA{width:20px}", ""]);
// Exports
exports.locals = {
	"title": "_5b2ROa0p33lkUmzqOZnHC",
	"image": "_3q6xHD6HXBPeRAC20i6Hfu",
	"oneNoteIcon": "_2-EZ4euowYj-m7jtrkmKQA"
};